export default __webpack_public_path__ + "ce8d56614d528fd19b25ae5a18bdc7a9.png";